var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.833 8l5.875 5.875c.195.194.292.43.292.708a.964.964 0 01-.292.709.965.965 0 01-.708.291.965.965 0 01-.708-.291l-6.23-6.23a1.435 1.435 0 01-.333-.5 1.554 1.554 0 010-1.124c.07-.181.18-.348.334-.5L7.292.708A.964.964 0 018 .417c.278 0 .514.097.708.291.195.195.292.43.292.709a.964.964 0 01-.292.708L2.833 8z",
    fill: "#fff"
  })));
}
export default SvgArrowBack;